import React from 'react';
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import PortfolioSection from "../components/PortfolioSection";
import Testimonials from "../components/Testimonials";
import TrustedClients from "../components/TrustedClients";
import VideoTestimonials from "../components/VideoTestimonials";
import Contact from "../components/Contact";
import Cursor from "../components/Cursor";
import CTA from "../components/CTA";
import Footer from "../components/Footer";
import WhatsAppButton from '../components/WhatsAppButton';

const Portfolio = () => {
    return (
        <div className="text-white min-h-screen relative z-10">
            <Navbar />
            <Hero
                badge="Our Portfolio"
                title={<>Transform Your <br /> <span className="text-[#F2B135]">Digital Vision</span> <br /> Into Reality.</>}
                subtitle="RojrzTech is a leading software and digital marketing agency specializing in custom Web Development and Branding."
                image="/portfolio.jpeg"

                // Buttons
                primaryBtnText="Start Your Project"
                primaryBtnLink="/contact"
                secondaryBtnText="About Us"
                secondaryBtnLink="/about"

                // Cards data
                rating="4.9/5"
                clientCount="49+ Worldwide"
            />
            <Cursor />
            <main className="relative z-10 w-full">
                <PortfolioSection />
                <VideoTestimonials />
                <Testimonials />
                <TrustedClients />
                <Contact />
                <CTA />
                <Footer />
                <WhatsAppButton />
            </main>
        </div>
    );
};

export default Portfolio;